<template>
    <div id="CompanyIntroduction">
        <div class="banner container-fuild text-center"></div>
        <div class="container">
            <div class="row CompanyIntroduction-container">
                <div class="col-xs-12 col-sm-12 col-md-6 wow zoomIn">
                    <img class="img-responsive center-block" src="@/assets/img/about_img.png">
                </div>
                <div class="col-xs-12 col-sm-12 col-md-6">
                    <h3>北京育体科技有限公司</h3>
                    <p class=".text-justify">赛点通专注于赛事情报、实时比分、联赛赛程、球员资讯，旨为广大足篮球比赛爱好者提供即时详尽的比分分析预测方案</p>
                    <p class=".text-justify">【情报解密】</p>
                    <p class=".text-justify">百余位实战名家不间断提供各大联赛实时详细分析，从走势、伤停及赛前情报，多维度分析足球篮球赛事，助您赛前决策不迷茫；</p>
                    <p class=".text-justify">【实时数据】</p>
                    <p class=".text-justify">涵盖全球主流联赛排行榜、球队阵容、球员综合数据，手机随时随地看比分，即时全面掌握体育圈数据趋势；</p>
                    <p class=".text-justify">【五大联赛】</p>
                    <p class=".text-justify">热门联赛球队球员数据，赛程积分、球员状态、近期战绩、交锋记录、数据统计，助您多维度全面分析球队综合实力；</p>
                    <p class=".text-justify">【专业比分】</p>
                    <p class=".text-justify">涵盖中超、亚冠、英超、意甲、西甲、德甲、日职联、澳超、欧冠、NBA、CBA等全球1000家体育赛事，实时捕获赛场一手比分动向。</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { WOW } from 'wowjs';
export default {
    name: 'CompanyIntroduction',
    data(){
        return{

        }
    },
    mounted(){
        var wow = new WOW();
        wow.init();
    }
}
</script>
<style scoped>
.banner{
    color: #fff;
    font-size: 30px;
    height: 150px;
    line-height: 150px;
    background-image: url('../assets/img/banner1.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: scroll;
    background-position: center center;
}
.row{
    margin-right: 0;
    margin-left: 0;
}
.CompanyIntroduction-container{
    padding: 100px 0;
    color: #808080;
    transition: all ease 0.5s;
}
.CompanyIntroduction-container>div>p{
    font-size: 14px;
    line-height: 2.5rem;
}
@media screen and (max-width: 997px){
    .CompanyIntroduction-container{
    padding: 10px 0;
    color: #808080;
}
}
</style>




// WEBPACK FOOTER //
// src/view/HomePage.vue